import theme from '../../base';

const globals = {
  body: {
    bg: theme.colors.neutrals.gray250,
    foreground: theme.colors.neutrals.gray800,
  },
  anchor: {
    foreground: theme.colors.blues.blue700,
    foregroundHover: theme.colors.blues.blue500,
    foregroundActive: theme.colors.blues.blue700,
  },
};

export default globals;
